let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3Ha0P"), load("fId8x"), load("dH2J7"), load("ePOyH"), load("7HLIY"), load("aHCaB")]).then(() => parcelRequire('3omFm'));